<template>
  <div>
  
    <div>
      <div>
      </div>
      <div class="w-full flex justify-between items-center">
        <div>
          <!-- {{validateTodayDate()}} -->
          <h3><strong>{{ eachEventInfo.title }}</strong></h3>
        </div>
        <div class="flex justify-end" vs-align="flex-end">
          <vs-button
            radius
            v-if="checkEditPermission() && validateTodayDate() <= 0"
            @click="editingEvent(eachEventInfo.id)"
            icon="edit"
            color="primary"
            class="mr-2"
            vs-type="flex"
            style="margin-right: 0"
          />
          <vs-button
          v-if="checkDeletePermission()"
            radius
            icon="delete"
            color="danger"
            vs-type="flex"
            style="margin-right: 0"
            @click="openDeletePopUp(eachEventInfo.id)"
          />
        </div>
        <!-- time and date -->
      </div>
      <strong>Description</strong>
      <p
        v-html="eachEventInfo.extendedProps.description"
        v-if="eachEventInfo.extendedProps.description"
      ></p>
    </div>

    <!-- teacher details -->
    <div class="flex flex-wrap my-4">
      <div class="teacher-info">
        <div>
          <feather-icon icon="MapPinIcon" />
        </div>
        <div class="ml-2">
          <strong>Location</strong>
          <p v-if="eachEventInfo.extendedProps.location">
            {{ eachEventInfo.extendedProps.location }}
          </p>
        </div>
      </div>
      <!-- <div class="teacher-info">
        <div>
          <feather-icon icon="TagIcon" />
        </div>
      </div> -->
      <div class="teacher-info">
        <div>
          <feather-icon icon="CalendarIcon" />
        </div>
        <div class="ml-2">
          <strong>Start Timing</strong>
          <p>{{ eachEventInfo.extendedProps.startTiming }}</p>
        </div>
      </div>
      <div class="teacher-info">
        <div>
          <feather-icon icon="CalendarIcon" />
        </div>
        <div class="ml-2">
          <strong>End Timing</strong>
          <p>{{ eachEventInfo.extendedProps.endTiming }}</p>
        </div>
      </div>
    </div>

    <!-- students list -->
    <vs-tabs>
      <vs-tab label="Staff">
        <div v-if="eachEventInfo.extendedProps.user_participants">
          <div
            v-for="(eachUser, index) in eachEventInfo.extendedProps
              .user_participants"
            :key="index"
            class="flex items-center my-2"
          >
            <div>
              
              <img
                src="/img/avatar-s-11.1a620230.jpg"
                alt="user-img"
                width="40"
                height="40"
                class="rounded-full shadow-md block"
              />
            </div>
            <div class="ml-2">
              {{ eachUser.user.first_name }} {{ eachUser.user.last_name }}
            </div>
          </div>

          <!-- <pre> {{ eachEventInfo.extendedProps.user_participants }}</pre> -->
        </div>
      </vs-tab>
      <vs-tab label="Client">
         <div v-if="eachEventInfo.extendedProps.client_participants">
           <!-- <pre> {{eachEventInfo.extendedProps.client_participants}}</pre> -->
          </div> 
          <!-- <pre>{{client_participants}}</pre> -->
         <div
          v-for="(eachUser, index) in eachEventInfo.extendedProps
            .client_participants"
          :key="index"
          class="flex items-center my-2"
        >
          <div>
            <img
              src="/img/avatar-s-11.1a620230.jpg"
              alt="user-img"
              width="40"
              height="40"
              class="rounded-full shadow-md block"
            />
          </div>
          <div class="ml-2">
            {{ eachUser.client_user.first_name }} {{ eachUser.client_user.last_name }}
          </div>
        </div> 
      </vs-tab>
    </vs-tabs>
    <vs-popup
      classContent="popup-example"
      title="Please Confirm"
      :active.sync="showPopUpBool"
    >
      <h4>Are you sure to delete this event?</h4>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click="deleteEvent(deleteEventIndex)">Confirm</vs-button>
        <vs-button type="border" color="danger" @click="showPopUpBool = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import moment from 'moment'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'

import { DeleteScheduleApi } from '@/api/schedulerApi.js'

export default {
  mixins:[PermissionMiddleware],
  props: {
    eachEventInfo: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showPopUpBool: false,
      deleteEventIndex: null
    }
  },
  created () {
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission == 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Schedule')
    }
  },
  methods: {
    openDeletePopUp (deleteEventIndex) {
      this.deleteEventIndex = deleteEventIndex
      this.showPopUpBool = true
    },
    validateTodayDate () {
      const today = moment(new Date())
      const selectedDate = moment(this.eachEventInfo.start)
      const differenceDate = today.diff(selectedDate, 'days')
      return differenceDate
    },
    editingEvent (id) {
      this.$emit('editingEvent', id)
      
    },
    async deleteEvent (id) {
      
      try {
        const customer_id = this.$store.getters.customerId
        await DeleteScheduleApi(customer_id, id)
        this.showPopUpBool = false
        this.showSuccessMessage(
          'success',
          'Event Deleted Successfully',
          'success'
        )
        this.$emit('eventEmitDeleted', id)
      } catch (error) {
        
      }
    }
  }
}
</script>